import React from "react";
import { motion } from "framer-motion";
import GlassCube from "../ui/glass-cube";

const GetStartedButton: React.FC = () => {
  return (
    <motion.a
      href="#contact"
      className="
        inline-flex items-center gap-2
        px-8 py-4 rounded-full text-lg font-semibold
        bg-gradient-to-r from-blue-600 to-emerald-600
        hover:from-blue-700 hover:to-emerald-700
        text-white
        transition-all duration-300
        shadow-[0_0_20px_rgba(59,130,246,0.3)]
        hover:shadow-[0_0_25px_rgba(59,130,246,0.4)]
      "
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      Get Started
    </motion.a>
  );
};

const LearnMoreButton: React.FC = () => {
  return (
    <motion.a
      href="#solution"
      className="
        px-8 py-4 rounded-full border-2 border-blue-500 
        text-blue-400 font-semibold 
        hover:bg-blue-500/10 transition-all duration-300
      "
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      Learn More
    </motion.a>
  );
};

const ShowcaseSection: React.FC = () => {
  return (
    <section id="products" className="relative min-h-screen py-20 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 to-blue-900/30 z-0" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <h2 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-400">
              The AI That Insurance Has Been Waiting For
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed">
              This isn't just another software upgrade. <span className="text-blue-400 font-semibold">Solvrays deploys AI "genes"</span> that literally think, learn, and evolve with your business. 
              Watch as our <span className="text-emerald-400 font-semibold">PulseGene</span> orchestrates data flows faster than your coffee gets cold, 
              while <span className="text-purple-400 font-semibold">RouteGene</span> manages workflows that adapt in real-time to changing conditions.
            </p>
            <div className="bg-gray-800/50 p-6 rounded-lg border border-blue-500/20">
              <p className="text-lg text-gray-200 italic">
                "This is like a command center for insurance operations. 
                Everything we need to orchestrate our workflows, manage our data flows, and integrate our systems - all in one intelligent platform."
              </p>
              <p className="text-blue-400 font-semibold mt-2">- Seasoned Operational Head, Major Insurance Firm</p>
            </div>
            <div className="flex gap-4">
              <GetStartedButton />
              <LearnMoreButton />
            </div>
          </motion.div>

          {/* Right content - Glass Cube */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative h-[600px]"
          >
            <GlassCube className="w-full h-full" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ShowcaseSection;
